import {combineReducers} from 'redux';
import requestReducer from './requestReducer';
import authReducer from './authReducer';
import dashboardReducer from './dashboardReducer';
import filterReducer from "./filterReducer";
import mapCarsReducer from "./mapCarsReducer";
import mapRoutesReducer from "./mapRoutesReducer";
import mapReducer from "./mapReducer";
import rentReducer from './rentReducer';
import carsReducer from "./carsReducer";
import groupReducer from "./groupReducer";
import reportReducer from "./reportReducer";
import driverReducer from "./driverReducer";
import userReducer from "./userReducer";
import settingsReducer from "./settingsReducer";

export default combineReducers({
    requestReducer,
    authReducer,
    dashboardReducer,
    filterReducer,
    mapCarsReducer,
    mapRoutesReducer,
    mapReducer,
    rentReducer,
    carsReducer,
    groupReducer,
    reportReducer,
    driverReducer,
    userReducer,
    settingsReducer
});
